module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "model": _vm.mappedEvents,
      "columns": _vm.computedColumns,
      "show-search": _vm.showSearch,
      "size": _vm.events.length,
      "order": {
        ascending: false,
        sortBy: 'occured'
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-91e5f0d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/EventTable.vue
// module id = 1173
// module chunks = 2